<script setup>
import { computed } from 'vue';
import { useDateFormat } from '@vueuse/core';
defineProps({
  date: {
    type: String,
    default: () => '',
  },
  title: {
    type: String,
    default: () => '',
  },
  url: {
    type: String,
    default: () => '',
  },
  theme: {
    type: String,
    default: () => '',
  },
});

const formattedDates = computed(() => {
  return useDateFormat(props.date, 'DD.MM.YYYY');
});
</script>
<template>
  <CTagDetect target="_target" :to="url" :class="`report report--${theme}`">
    <div class="report__top">
      <p
        v-if="title"
        :class="['report__title m-0 h5', theme === 'black' ? 'white' : '']"
        v-html="title"
      ></p>
      <div v-if="date" class="report__item-date body-3-regular">
        {{ formattedDates }}
      </div>
    </div>
  </CTagDetect>
</template>
<style scoped lang="scss">
@use 'sass:math';
.report {
  align-items: center;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  padding: 24px 24px 16px;
  min-height: 192px;
  @include media-breakpoint-up(sm) {
    gap: 24px;
    padding: 40px 40px 24px;
    min-height: 250px;
  }
  @include media-breakpoint-up(md) {
    gap: 24px;
    padding: 40px 40px 24px;
    min-height: 279px;
  }
  @include media-breakpoint-up(xl) {
    @include responsive-spacing(border-radius, 8);
    @include responsive-spacing(gap, 24);
    @include responsive-spacing(padding, 40);
    @include responsive-spacing(padding-bottom, 24);
    @include responsive-spacing(min-height, 279);
  }
  &--white {
    background-color: $gray;
  }
  &--black {
    background-color: rgba($surface-container-opacity, 0.5);
  }
  &--gray {
    background-color: $white;
  }
  &__top {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 18px;
    @include media-breakpoint-up(sm) {
      gap: 24px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 24);
    }
  }
  &__title {
    display: -webkit-box;
    -webkit-line-clamp: 6;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-align: center;
    @include media-breakpoint-up(sm) {
      -webkit-line-clamp: 7;
    }
  }
  &__button {
    margin-top: auto;
  }
}
</style>
